import React from 'react';
import { Home, Bed, Bath, MoreVertical } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from './ui/dropdown-menu';
import AddressVerificationBadge from './AddressVerificationBadge';

const PropertyListItem = ({ property, onEdit, onDelete, formatDate }) => {
  return (
    <div className="bg-white border-b border-[#E2E8F0] px-6 py-4 hover:bg-[#F8FAFC] transition-colors">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4 flex-1">
          <div className="w-10 h-10 rounded bg-[#F1F5F9] flex items-center justify-center flex-shrink-0">
            <Home className="w-5 h-5 text-[#16A34A]" />
          </div>

          <div className="flex-1 grid grid-cols-[2fr_2fr_1fr_2fr_1fr] gap-4 items-center min-w-0">
            <div className="min-w-0">
              <h3 className="text-sm text-[#030712] font-medium truncate">{property.name}</h3>
              <div className="flex items-center gap-1.5 min-w-0">
                <p className="text-xs text-[#64748B] truncate">{property.address}</p>
                <AddressVerificationBadge
                  verified={property.address_verified}
                  verdict={property.address_validation_verdict}
                  compact
                />
              </div>
            </div>

            <div className="flex items-center gap-3 text-xs text-[#64748B]">
              <div className="flex items-center gap-1">
                <Bed className="w-3.5 h-3.5" />
                <span>{property.bedrooms ?? 0}</span>
              </div>
              <div className="flex items-center gap-1">
                <Bath className="w-3.5 h-3.5" />
                <span>{property.bathrooms ?? 0}</span>
              </div>
              {property.property_type && (
                <span>{property.property_type}</span>
              )}
            </div>

            <div className="text-xs text-[#64748B]">
              {formatDate(property.date_added)}
            </div>

            <div className="min-w-0">
              <p className="text-xs text-[#64748B] truncate">
                {property.description || '--'}
              </p>
            </div>

            <div className="flex justify-end">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <button className="p-1 hover:bg-[#F1F5F9] rounded transition-colors">
                    <MoreVertical className="w-5 h-5 text-[#64748B]" />
                  </button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem onClick={() => onEdit(property)}>
                    Edit
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    className="text-[#EF4444] focus:text-[#EF4444] focus:bg-[#FEF2F2]"
                    onClick={() => onDelete(property)}
                  >
                    Delete
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyListItem;
